export default __webpack_public_path__ + "static/media/agentIcon.f378cc45.svg";